import { createSlice } from '@reduxjs/toolkit';

import { createSchool, getSchools } from './actions';

const schoolSlice = createSlice({
  name: 'schools',
  initialState: [],
  reducers: {},
  extraReducers: (builder: any) => {
    builder.addCase(getSchools.fulfilled, (_: any, action: any) => {
      return action.payload;
    });

    builder.addCase(createSchool.fulfilled, (state: any, action: any) => {
      state.push(action.payload);
    });
  },
});

export default schoolSlice.reducer;
